import * as React from 'react';
import { Button, Modal } from '@ixicare/ui';
import { t } from '~i18n';
import { Spacer } from '~components/Utils/Spacer';
import { DBG } from '~modules/devices/components/DeviceHealthTable/types';
import styles from '~/components/ActionBar/ActionBar.module.css';
import classnames from 'classnames';

const MAX_CHIPS = 7;

export function DeleteDeviceModal({
  onClose,
  onDelete,
  isPending,
  devices,
}: {
  onClose: () => void;
  onDelete: () => void;
  isPending: boolean;
  devices: DBG[];
}) {
  const shownDevices = devices.slice(0, MAX_CHIPS);
  const overflow = devices.length - shownDevices.length;

  return (
    <Modal style={{ maxWidth: 450 }}>
      <h3 className="text-center mb-10">{t('device.form.archive')}</h3>
      <ul className={styles.chips}>
        {shownDevices.map((device) => (
          <li className={classnames('text-center', 'mb-10', styles.chip)} key={device.macAddress}>
            {device.macAddress} - {device.description}
          </li>
        ))}
        {overflow > 0 && <li className={classnames('text-center', styles.chip)}>+{overflow}</li>}
      </ul>
      <Spacer size={32} />
      <Button
        className="mb-15 error"
        isBlock
        loading={isPending}
        buttonType="error"
        type="button"
        onClick={() => onDelete()}
      >
        {t('device.form.archive')}
      </Button>
      <Button onClick={() => onClose()} isBlock buttonType="link">
        {t('global.cancel')}
      </Button>
    </Modal>
  );
}
